export function datalayerPush(data: Record<string, unknown>) {
	const dataLayer = window.dataLayer;
	dataLayer?.push(data);
}
